import { MenuItem } from '@mui/material';
import { createLink } from '@tanstack/react-router';

const NavMenuItem = createLink(MenuItem);

export default NavMenuItem;
